import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import CircularProgress from "@mui/material/CircularProgress";
import { isUserSubscribed, upgradeToPremium, changePlan } from "../../Utils/functions";

const Checkout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuthenticator((ctx) => [ctx.user]);
  const plan = searchParams.get("plan") || "monthly";
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) {
      navigate(`/login?redirect=${encodeURIComponent(`/checkout?plan=${plan}`)}`);
      return;
    }

    const proceed = async () => {
      try {
        if (plan === "free") {
          navigate("/");
          return;
        }

        const { isActive, currentPlan } = await isUserSubscribed();

        if (isActive) {
          if (currentPlan === plan) {
            // Already on this plan
            navigate("/");
            return;
          }
          // Switch to different plan without a new Stripe checkout
          await changePlan(plan);
          navigate("/thankyou");
          return;
        }

        await upgradeToPremium(plan);
      } catch (err) {
        console.error("Checkout error:", err);
        setError(err.message || "Something went wrong. Please try again.");
      }
    };

    proceed();
  }, [user, plan, navigate]);

  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", flexDirection: "column", gap: "16px" }}>
        <p style={{ color: "#d32f2f" }}>{error}</p>
        <button onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Go to Home</button>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <CircularProgress sx={{ color: "#3b7b3f" }} />
    </div>
  );
};

export default Checkout;
